import type { RootState } from '@/components/WellLoggingOperations/types';
import { useSelector } from 'react-redux';

export const useSelectedWells = () => {
    const wellsKeys = useSelector((state: RootState) => state.templateWells.wellsKeys);
    const wells = useSelector((state: RootState) => state.templateWells.wells);

    const selectedWells = wells.filter(well => wellsKeys.includes(well.key));

    return selectedWells;
};
